// Centralized CSV column constants and helper builders

/** Lowercase emails allowed to use comparison CSV export in production (and all envs). */
export const CSV_EXPORT_ALLOWED_EMAILS: readonly string[] = ['heejun.seo@lmigroup.com']

export function isCsvExportAllowedForUser(email: string | null | undefined): boolean {
  if (!email || typeof email !== 'string') return false
  return CSV_EXPORT_ALLOWED_EMAILS.includes(email.trim().toLowerCase())
}

export const COL = {
  COVER_NAME: 'Cover Name',
  SECTION_NAME: 'Section Name',
  FEATURE_NAME: 'Feature Name',
  FEATURE_ID: 'Feature ID',
  POINT_TO_CONSIDER: 'Point to Consider',
  KEY_SELLING_FEATURE: 'Key Selling Feature',
  POLICY_NAME: 'Policy Name',
  POLICY_CODE: 'Policy Code',
  POLICY_INSURER: 'Policy Insurer',
  POLICY_WORDING_PATH: 'Policy Wording Path',
  POLICY_CONTENT: 'Policy Content',
  POLICY_ICON: 'Policy Icon',
  POLICY_PAGE: 'Policy Page',
} as const

export type ColumnName = (typeof COL)[keyof typeof COL]

export function policyNameAt(index: number): string {
  return `Policy ${index} Name`
}

export function policyCodeAt(index: number): string {
  return `Policy ${index} Code`
}

export function policyInsurerAt(index: number): string {
  return `Policy ${index} Insurer`
}

export function policyWordingPathAt(index: number): string {
  return `Policy ${index} Wording Path`
}

export function policyContentAt(index: number): string {
  return `Policy ${index} Content`
}

export function policyIconAt(index: number): string {
  return `Policy ${index} Icon`
}

export function policyPageAt(index: number): string {
  return `Policy ${index} Page`
}
